<template>
    <div class="custom-marker-wrapper" :class="open ? 'open' : 'closed'">
        <img :src="getImageSrc" class="custom-marker" @click="toggle"/>
    </div>
</template>
<script>
import MarkerDetails from '../../../../../modules/custom/nexdrive_base/js/components/MarkerDetails';
import ClickOutside from '../../../../../themes/custom/ef2_custom/node_modules/vue-click-outside';

export default {
    components: {
        'marker-details': MarkerDetails
    },

    directives: {
        ClickOutside
    },

    props: {
        marker: {
            type: Object,
            required: true
        },
        activeMarker: {
            type: Object,
            default: {}
        },
        eventBus: {}
    },

    computed: {
        getImageSrc() {
            if (this.marker.coming_soon) {
                return '/themes/custom/ef2_custom/images/marker-disabled.png';
            }
            return '/themes/custom/ef2_custom/images/marker.png';
        },

        open() {
            return _.isEqual(this.activeMarker.id, this.marker.id);
        }
    },

    methods: {
        toggle() {
            if (!this.open) {
                this.$emit('marker-clicked', this.marker.geolocation);
                this.$emit('active-marker', this.marker);
                return;
            }

            this.eventBus.$emit('remove-active-marker');
        },

        handleAlive() {
            this.popupItem = this.$refs.markerdetail.$el.getElementsByTagName('a');
        }
    }
}
</script>
